export default __webpack_public_path__ + "static/media/ic_sao_tome_and_prince.45ec9721.svg";